import AddOutlined from '@mui/icons-material/AddOutlined';
import BrushOutlined from '@mui/icons-material/BrushOutlined';
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import styles from './RowActionButton.module.css';

export type RowActionButtonVariant = 'add' | 'delete' | 'clear' | 'edit' | 'duplicate' | 'view';

interface RowActionButtonProps {
	variant: RowActionButtonVariant;
	onClick: () => void;
	disabled?: boolean;
	title?: string;
}

const ICONS: Record<RowActionButtonVariant, typeof AddOutlined> = {
	add: AddOutlined,
	delete: DeleteOutlineOutlined,
	clear: BrushOutlined,
	edit: EditOutlined,
	duplicate: ContentCopyOutlined,
	view: VisibilityOutlined,
};

const CLASS_BY_VARIANT: Record<RowActionButtonVariant, string> = {
	add: styles.addButton,
	delete: styles.deleteButton,
	clear: styles.deleteButton,
	edit: styles.ghostButton,
	duplicate: styles.ghostButton,
	view: styles.ghostButton,
};

export const RowActionButton = ({ variant, onClick, disabled, title }: RowActionButtonProps) => {
	const Icon = ICONS[variant];

	return (
		<button
			type="button"
			className={CLASS_BY_VARIANT[variant]}
			onClick={onClick}
			disabled={disabled}
			title={title}
			aria-label={title}
		>
			<Icon />
		</button>
	);
};
